exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?minimize!../node_modules/@syncfusion/ej2-base/styles/material.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?minimize!../node_modules/@syncfusion/ej2-popups/styles/material.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?minimize!../node_modules/@syncfusion/ej2-navigations/styles/material.css"), "");

// module
exports.push([module.id, "body[data-v-24456ff2]{margin-top:100px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24456ff2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_MenuBar.vue
// module id = 179
// module chunks = 0